import { DataObject, DataObjectFactory } from "@/v2/models/base-data-object.js";
import { Parameter } from "@/v2/models/parameters";


export class ShippingClass extends DataObject{
    _type = 'shipping_class';

    id;
    name;
    remarks;
}

export class ShippingClassMapperParameter extends Parameter{
    shippingClassMapper;
}

export class ShippingClassFactory {
    /**
     * Creates a new instance of a DataObject.
     * @function
     * @static
     * @param {ShippingClassMapperParameter} shippingClassMapperParameter Parameter object containing mappers that the factory expects.
     * @param {Object, null} data Data to construct the ShippingClass object with.
     * @returns {ShippingClass}
     */
    static construct(shippingClassMapperParameter, data = null){
        if(data != null){
            let shippingClass = DataObjectFactory.getInstance().construct(
                ShippingClass,
                data ? shippingClassMapperParameter.shippingClassMapper(data): null
            );

            return shippingClass;
        }

        return null;
    }
}
